import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const UtentiContext = React.createContext(null);

const { Provider } = UtentiContext;

export const UtentiProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        utenti: { result: [], totalCount: 0, },
    });

    const { utenti } = state;

    const [isLoadingUtenti, setIsLoadingUtenti] = useState(false);
    const getUtentiAsync = async (pageIndex = 0, pageSize = 100, term) => {
        try {
            setIsLoadingUtenti(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.GetUtenti({ pageIndex, pageSize, term }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
            })
            setState({ utenti: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUtenti(false);
        }
    }

    const [isDeletingUtente, setIsDeletingUtente] = useState(false);
    const deleteUtenteAsync = async (utenteId,) => {
        try {
            setIsDeletingUtente(true);
            if (window.confirm("Confermare la disabilitazione dell'utente?")) {
                const r = await fetchAuthorized(ApiRoutes.Utente.DeleteUtente({ utenteId }), {
                    method: HttpMethods.DELETE
                });
                const list = utenti.result;
                list.forEach(x => {
                    if (x.id == utenteId)
                        x.fineValidita = new Date();
                });
                setState({
                    utenti: {
                        ...utenti, result: list
                    }
                });
                showSuccessMessage(`Utente con id ${utenteId} disabilitato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingUtente(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingUtenti,
            getUtentiAsync,

            isDeletingUtente,
            deleteUtenteAsync,
        }}>
            {props.children}
        </Provider>
    );
}